(function () {
  var modal = document.querySelector('[data-search-modal]');
  var openers = document.querySelectorAll('[data-search-open]');
  var closeButtons = document.querySelectorAll('[data-search-close]');
  var form = document.querySelector('[data-predictive-search-form]');
  var input = document.querySelector('[data-predictive-search-input]');
  var resultsEl = document.querySelector('[data-predictive-search-results]');
  var statusEl = document.querySelector('[data-predictive-search-status]');
  var lastFocus = null;
  var activeController = null;
  var debounceTimer = null;
  var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  if (!modal || !form || !input || !resultsEl) return;

  function getFocusable(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll(focusableSelector)).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
  }

  function isSearchOpen() {
    return modal && !modal.hidden;
  }

  function trapSearchFocus(event) {
    if (event.key !== 'Tab' || !isSearchOpen()) return;
    var focusable = getFocusable(modal);
    if (!focusable.length) {
      event.preventDefault();
      input.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function rootUrl() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    return '/';
  }

  function stripHtml(value) {
    return String(value || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function isSafeUrl(url) {
    if (!url || typeof url !== 'string') return false;
    if (url.charAt(0) === '/' && url.charAt(1) !== '/') return true;
    try {
      var parsed = new URL(url.indexOf('//') === 0 ? window.location.protocol + url : url, window.location.origin);
      var host = parsed.hostname.toLowerCase();
      var protocolAllowed = parsed.protocol === 'https:' || parsed.protocol === 'http:';
      var hostAllowed = host === window.location.hostname.toLowerCase() ||
        host === 'fearlessharbor.com' ||
        host === 'www.fearlessharbor.com' ||
        host === 'cdn.shopify.com' ||
        host === 'cdn.shopifycdn.com' ||
        host === 'cdn.shopifycdn.net' ||
        host.endsWith('.myshopify.com') ||
        host.endsWith('.shopifycdn.com') ||
        host.endsWith('.shopifycdn.net');
      return protocolAllowed && hostAllowed;
    } catch (error) {
      return false;
    }
  }

  function safeUrl(url, fallback) {
    return isSafeUrl(url) ? url : fallback;
  }

  function clearElement(element) {
    while (element.firstChild) element.removeChild(element.firstChild);
  }

  function createTextElement(tagName, className, text) {
    var el = document.createElement(tagName);
    if (className) el.className = className;
    el.textContent = text || '';
    return el;
  }

  function submitUrl(term, type) {
    var root = rootUrl().replace(/\/?$/, '/');
    var params = new URLSearchParams();
    params.set('q', term);
    params.set('options[prefix]', 'last');
    if (type) params.set('type', type);
    return root + 'search?' + params.toString();
  }

  function suggestUrl(term) {
    var root = rootUrl().replace(/\/?$/, '/');
    return root + 'search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product,collection,article,page,query' +
      '&resources[limit]=4' +
      '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last';
  }

  function itemImage(item) {
    if (item.image) return typeof item.image === 'string' ? item.image : item.image.url;
    if (item.featured_image) return typeof item.featured_image === 'string' ? item.featured_image : item.featured_image.url;
    return '';
  }

  function resultRow(item, type) {
    var title = stripHtml(item.title || item.text || '');
    var url = item.url || submitUrl(title, type === 'query' ? null : type);
    var image = itemImage(item);
    var body = item.body || item.summary || item.content || '';
    var label = type === 'article' ? 'Field Note' : type.charAt(0).toUpperCase() + type.slice(1);
    var link = document.createElement('a');
    var media = document.createElement('span');
    var resultBody = document.createElement('span');

    if (type === 'query') {
      url = submitUrl(title);
      label = 'Suggested search';
    }

    link.className = 'fh-search-result';
    link.setAttribute('href', safeUrl(url, submitUrl(title, type === 'query' ? null : type)));

    media.className = 'fh-search-result__media';
    if (image && isSafeUrl(image)) {
      var img = document.createElement('img');
      img.src = image;
      img.alt = '';
      img.loading = 'lazy';
      media.appendChild(img);
    } else {
      media.classList.add('fh-search-result__media--empty');
      media.setAttribute('aria-hidden', 'true');
    }

    resultBody.className = 'fh-search-result__body';
    resultBody.appendChild(createTextElement('span', 'fh-search-result__type', label));
    resultBody.appendChild(createTextElement('span', 'fh-search-result__title', title));
    if (body) {
      resultBody.appendChild(createTextElement('span', 'fh-search-result__excerpt', stripHtml(body).slice(0, 120)));
    }

    link.appendChild(media);
    link.appendChild(resultBody);
    return link;
  }

  function groupElement(title, items, type) {
    if (!items || !items.length) return null;
    var section = document.createElement('section');
    var list = document.createElement('div');

    section.className = 'fh-search-group';
    section.setAttribute('aria-label', title);
    section.appendChild(createTextElement('h3', '', title));
    list.className = 'fh-search-group__list';
    items.forEach(function (item) {
      list.appendChild(resultRow(item, type));
    });
    section.appendChild(list);
    return section;
  }

  function renderEmptyState(term) {
    var empty = document.createElement('div');
    var link = document.createElement('a');

    empty.className = 'fh-search-modal__empty';
    empty.appendChild(createTextElement('h3', '', 'No quick results'));
    empty.appendChild(createTextElement('p', '', 'Press Enter to run a full site search.'));
    link.className = 'btn btn--secondary';
    link.setAttribute('href', submitUrl(term));
    link.textContent = 'Search for ' + term;
    empty.appendChild(link);
    return empty;
  }

  function renderUnavailableState() {
    var empty = document.createElement('div');
    empty.className = 'fh-search-modal__empty';
    empty.appendChild(createTextElement('h3', '', 'Search is unavailable'));
    empty.appendChild(createTextElement('p', '', 'Press Enter to use the standard search page.'));
    return empty;
  }

  function renderAllResultsLink(term) {
    var link = document.createElement('a');
    link.className = 'fh-search-modal__all';
    link.setAttribute('href', submitUrl(term));
    link.textContent = 'View all results for "' + term + '"';
    return link;
  }

  function renderResults(term, resources) {
    var results = resources && resources.results ? resources.results : {};
    var groups = [
      groupElement('Products', results.products, 'product'),
      groupElement('Collections', results.collections, 'collection'),
      groupElement('Field Notes', results.articles, 'article'),
      groupElement('Pages', results.pages, 'page'),
      groupElement('Suggested searches', results.queries, 'query')
    ].filter(Boolean);

    clearElement(resultsEl);
    if (!groups.length) {
      resultsEl.appendChild(renderEmptyState(term));
      if (statusEl) statusEl.textContent = 'No predictive results. Press Enter to search.';
      return;
    }

    groups.forEach(function (group) {
      resultsEl.appendChild(group);
    });
    resultsEl.appendChild(renderAllResultsLink(term));
    if (statusEl) statusEl.textContent = 'Predictive results loaded.';
  }

  function runSearch() {
    var term = input.value.trim();
    window.clearTimeout(debounceTimer);

    if (activeController) activeController.abort();

    if (term.length < 2) {
      clearElement(resultsEl);
      if (statusEl) statusEl.textContent = 'Start typing to search products, collections, pages, and Field Notes.';
      return;
    }

    debounceTimer = window.setTimeout(function () {
      activeController = new AbortController();
      if (statusEl) statusEl.textContent = 'Searching...';

      fetch(suggestUrl(term), {
        headers: { Accept: 'application/json' },
        signal: activeController.signal
      }).then(function (response) {
        if (!response.ok) throw new Error('Predictive search failed');
        return response.json();
      }).then(function (json) {
        renderResults(term, json.resources);
      }).catch(function (error) {
        if (error.name === 'AbortError') return;
        clearElement(resultsEl);
        resultsEl.appendChild(renderUnavailableState());
        if (statusEl) statusEl.textContent = 'Predictive search unavailable.';
      });
    }, 180);
  }

  function openSearch(event) {
    if (event) event.preventDefault();
    lastFocus = document.activeElement;
    modal.hidden = false;
    modal.removeAttribute('inert');
    modal.setAttribute('aria-hidden', 'false');
    openers.forEach(function (opener) {
      opener.setAttribute('aria-expanded', 'true');
    });
    document.documentElement.classList.add('fh-search-is-open');
    window.setTimeout(function () { input.focus(); }, 20);
  }

  function closeSearch() {
    if (!isSearchOpen()) return;
    modal.hidden = true;
    modal.setAttribute('inert', '');
    modal.setAttribute('aria-hidden', 'true');
    openers.forEach(function (opener) {
      opener.setAttribute('aria-expanded', 'false');
    });
    document.documentElement.classList.remove('fh-search-is-open');
    if (activeController) activeController.abort();
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function moveFocus(event) {
    var links = resultsEl.querySelectorAll('a');
    if (!links.length) return;
    var currentIndex = Array.prototype.indexOf.call(links, document.activeElement);

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      links[Math.min(currentIndex + 1, links.length - 1)].focus();
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      if (currentIndex <= 0) {
        input.focus();
      } else {
        links[currentIndex - 1].focus();
      }
    }
  }

  openers.forEach(function (opener) {
    opener.addEventListener('click', openSearch);
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeSearch);
  });

  input.addEventListener('input', runSearch);
  modal.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeSearch();
      return;
    }
    trapSearchFocus(event);
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') moveFocus(event);
  });

  form.addEventListener('submit', function (event) {
    if (!input.value.trim()) event.preventDefault();
  });
})();
